<template>
  <section class="equipment-row" @mouseover="$emit('hover', sectionId)">
    <div :id="isEquipmentPreview ? undefined : `${sectionId}`" class="anchor" />
    <slot>EQUIPMENT BASE SLOT</slot>
  </section>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { equipmentPreviewKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
const isEquipmentPreview = inject(equipmentPreviewKey, false);
defineProps({
  sectionId: {
    type: String,
    required: true
  }
});

defineEmits<{
  (event: "hover", sectionId: string): void;
}>();
</script>

<style lang="scss">
.equipment-row {
  padding-top: 2em;
  padding-bottom: 3em;
  padding-left: 3em;
  padding-right: 1em;
  border-bottom: 1px solid var(--border-main);
  background-image: var(--gradient-vertical);
}
.anchor {
  position: relative;
  top: -15vh;
}
@media only screen and (max-width: 750px) {
  .equipment-row {
    padding-left: 1em;
    padding-right: 1em;
    width: 100vw;
  }
}
</style>
